/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from 'components';

import { LocalContextProvider } from './src/context/LocalContext';

export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;

export const wrapRootElement = ({ element }) => (
  <LocalContextProvider>{element}</LocalContextProvider>
);

export const replaceHydrateFunction = () => (element, container) => {
  const root = ReactDOM.createRoot(container);
  root.render(element);
};

export const onClientEntry = () => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require
    // const whyDidYouRender = require('@welldone-software/why-did-you-render');
    // whyDidYouRender(React, {
    //   trackAllPureComponents: true
    // });
  }
};

// Solves a provlem with gatsby-plugin-offline...
// https://stackoverflow.com/questions/58225352/need-to-refresh-previously-vistied-gatsby-site-to-view-changes
// export const onServiceWorkerUpdateReady = () => {
//   const queryParams = queryString.parse(window.location.search);
//   const { mode } = queryParams;
//   if (!mode) {
//     // eslint-disable-next-line no-alert
//     const answer = window.confirm(
//       // eslint-disable-next-line no-useless-concat
//       `This application has been updated. ` + `Reload to display the latest version?`
//     );
//     if (answer === true) {
//       console.log('Service worker update ready. Refreshing site.');
//       window.location.reload();
//     }
//   }
// };
